export default __webpack_public_path__ + "static/media/lab8.18ef43b6.jpg";